import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiClock, FiMapPin, FiUsers } = FiIcons;

const Events = () => {
  return (
    <section id="events" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/50 via-emerald-900/50 to-purple-900/50"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400" style={{ fontFamily: 'fantasy, serif' }}>
            Guild Events
          </h2>
          <p className="text-white text-xl max-w-2xl mx-auto">
            Join us for epic adventures and legendary conquests
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <motion.div
            className="bg-gradient-to-br from-blue-900/80 to-emerald-900/80 p-8 rounded-3xl shadow-2xl border-2 border-blue-500/50 backdrop-blur-sm relative overflow-hidden group"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.02 }}
          >
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-yellow-500/20 to-transparent rounded-bl-full"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-emerald-500/20 to-transparent rounded-tr-full"></div>
            
            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-emerald-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl"></div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-full flex items-center justify-center shadow-lg shadow-blue-500/50">
                  <SafeIcon icon={FiMapPin} className="text-3xl text-white" />
                </div>
              </div>
              
              <h3 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400">
                Sky Tower Run
              </h3>
              
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center p-4 bg-gradient-to-br from-blue-500/20 to-emerald-500/20 rounded-xl border border-blue-500/30">
                  <SafeIcon icon={FiCalendar} className="text-2xl text-blue-400 mx-auto mb-2" />
                  <p className="text-white font-semibold">Every Sunday</p>
                  <p className="text-blue-300">& Thursday</p>
                </div>
                
                <div className="text-center p-4 bg-gradient-to-br from-emerald-500/20 to-blue-500/20 rounded-xl border border-emerald-500/30">
                  <SafeIcon icon={FiClock} className="text-2xl text-emerald-400 mx-auto mb-2" />
                  <p className="text-white font-semibold">15:00</p>
                  <p className="text-emerald-300">Server Time</p>
                </div>
                
                <div className="text-center p-4 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-xl border border-purple-500/30">
                  <SafeIcon icon={FiUsers} className="text-2xl text-purple-400 mx-auto mb-2" />
                  <p className="text-white font-semibold">All Members</p>
                  <p className="text-purple-300">Welcome</p>
                </div>
              </div>
              
              <div className="text-center">
                <p className="text-white text-lg mb-6 leading-relaxed">
                  Ascend the mystical Sky Tower and claim legendary rewards! 
                  This challenging dungeon requires teamwork, strategy, and courage. 
                  All guild members are welcome to join this epic adventure.
                </p>
                
                <motion.button
                  className="bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-500 hover:to-emerald-500 text-white px-8 py-3 rounded-full font-bold shadow-xl shadow-blue-500/30 transition-all duration-300"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Join Event
                </motion.button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Events;